export const PRODUCT_URL = '/shop';
export const STORE_URL = 'https://mencore-2.myshopify.com';

export const VARIANT_ID = '52939069030738';
export const PRODUCT_PRICE = 24.99;
export const SUBSCRIBE_PRICE = 21.99;
export const BUNDLE_2_PRICE = 49.98;

// Update SUBSCRIBE_URL with your Shopify selling_plan URL once subscriptions are configured
export const SUBSCRIBE_URL = 'https://mencore-2.myshopify.com/products/reload-male-libido-botanical-formula-60-capsules';
export const buildCheckoutUrl = (qty) =>
  `https://mencore-2.myshopify.com/cart/52939069030738:${qty}?checkout`;

export const PRODUCT_IMAGES = {
  singleBottle:
    "https://customer-assets.emergentagent.com/job_89897a2f-da0f-442c-92e9-3b70bf1115c6/artifacts/f0qwm6ij_Render_Mockup_1920_1920_2026-03-14.jpg",
  twoBottles:
    "https://customer-assets.emergentagent.com/job_89897a2f-da0f-442c-92e9-3b70bf1115c6/artifacts/1znzjua8_Render_Mockup_1920_1920_2026-03-14-2.jpg",
  floatingBottles:
    "https://customer-assets.emergentagent.com/job_89897a2f-da0f-442c-92e9-3b70bf1115c6/artifacts/a2we93yz_Render_Mockup_4000_3000_2026-03-21.png",
  threeBottles:
    "https://customer-assets.emergentagent.com/job_89897a2f-da0f-442c-92e9-3b70bf1115c6/artifacts/zy7vswia_Render_Mockup_4000_4000_2026-03-21-2.jpg",
  multipleBottles:
    "https://customer-assets.emergentagent.com/job_89897a2f-da0f-442c-92e9-3b70bf1115c6/artifacts/mm5ycxk6_Render_Mockup_4000_4000_2026-03-21-2.png",
};
